module.exports = {"610521001":"华州街道","610521101":"杏林镇","610521102":"赤水镇","610521103":"高塘镇","610521104":"大明镇","610521105":"瓜坡镇","610521106":"莲花寺镇","610521107":"柳枝镇","610521108":"下庙镇","610521109":"金堆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610521.json
// module id = 2823
// module chunks = 0